/**
 * Tracks server-derived authorization independently from route identity.
 * A request may still target the same conversation after a role demotion, so
 * route-only request guards are insufficient for privileged data.
 */
export function createConversationAuthorizationEpoch(initialFingerprint: string) {
  let fingerprint = initialFingerprint;
  let epoch = 0;

  return {
    update(nextFingerprint: string): boolean {
      if (nextFingerprint === fingerprint) {
        return false;
      }
      fingerprint = nextFingerprint;
      epoch += 1;
      return true;
    },
    capture(): number {
      return epoch;
    },
    accepts(requestEpoch: number): boolean {
      return requestEpoch === epoch;
    }
  };
}
